import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>University History</h1>
                <p>Home &gt; About-us &gt; University History</p>
            </div>
        </div>
    )
}

export default Hero;